const translations = {
  "common.loading": "Loading...",
  "common.cancel": "Cancel",
  "common.ok": "OK",
  "common.save": "Save",
  "common.close": "Close",
  "common.back": "Back",
  "common.next": "Next",
  "common.done": "Done",
  "common.yes": "Yes",
  "common.no": "No",
  "common.confirm": "Confirm",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.change": "Change",
  "common.submit": "Submit",
  "common.subscribe": "Subscribe",
  "common.link-my-card": "Link my card",
  "common.add-new-card": "Add new",
  "common.how-it-works": "How it works",
  "common.continue": "Continue",
  "common.upgrade": "Upgrade",
  "common.card.select": "Select a card",
  "common.review": "Review",
  "common.renew": "Renew",
  "common.please.wait.first": "Processing, please wait.",
  "common.please.wait.second": "This could take a few seconds.{newline}Don't refresh or close the page.",
  "common.switch": "Switch",
  "common.select": "Select",
  "common.monthly": "monthly",
  "common.annual": "annual",
  "common.total": "Total",
  "common.step": "{current} of {total}",
  "common.copy": "Copy",
  "common.frequency.short.month": "/mo",
  "common.frequency.long.month": "/month",
  "common.frequency.short.year": "/yr",
  "common.frequency.long.year": "/year",
};

export default translations;
